
import { EventParticipationSlot } from "@/models";
import { defineComponent, PropType } from "@vue/runtime-core";
export default defineComponent({
	name: "EventParticipationSlotScoreRenderer",
	props: {
		params: {
			type: Object as PropType<{ value: Pick<EventParticipationSlot, "has_answer"> }>,
			required: true,
		},
	},
	methods: {},
	computed: {
		hasAnswer() {
			return (
				// TODO add has_answer to interface
				(this.params.value as any).has_answer
			);
		},
	},
	components: {},
});
